import { render, staticRenderFns } from "./NotificationAllList.vue?vue&type=template&id=16d2670c&"
import script from "./NotificationAllList.vue?vue&type=script&lang=js&"
export * from "./NotificationAllList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports